import { SegmentController } from "components/designV2/segmentcontroller/segmentcontroller";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export type ViewMode = "xml" | "list";

interface ViewModeSwitcherProps {
  onChange?: (mode: ViewMode) => void;
  defaultMode?: ViewMode;
}

export const ViewModeSwitcher: React.FC<ViewModeSwitcherProps> = ({
  onChange,
  defaultMode = "list",
}) => {
  const [viewMode, setViewMode] = useState<ViewMode>(defaultMode);
  const { t } = useTranslation();

  const handleToggle = (mode: ViewMode) => {
    setViewMode(mode);
    onChange?.(mode);
  };

  return (
    <SegmentController
      options={[
        { value: "xml", label: t("Salary.XML") },
        { value: "list", label: t("Salary.List") },
      ]}
      value={viewMode}
      onChange={handleToggle}
    />
  );
};
